// generated by the plop

import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { AuthStateModel, GpAuthService, LoginSuccess, LogoutSuccess, ResetAuthState } from 'gp-auth';
import { LoadUserRoles, UpdateProfile, UpdateProfileFail, UpdateProfileSuccess } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';
import { ProfileService } from '../../profile.service';
import { LoadCurrentUser, LoadCurrentUserFail, LoadCurrentUserSuccess } from './profile.actions';
import { PROFILE_STATE_DEFAULT, ProfileStateModel } from './profile.model';

@State({ name: 'profile', defaults: PROFILE_STATE_DEFAULT })
@Injectable()
export class ProfileState implements NgxsOnInit {

  @Selector()
  static currentUser(state: ProfileStateModel): ProfileStateModel['currentUser'] {
    return state?.currentUser;
  }

  constructor(private service: ProfileService, private authService: GpAuthService) {
  }

  ngxsOnInit(ctx: StateContext<AuthStateModel>): void {
    const token = this.authService.getToken();
    if (token) {
      ctx.dispatch(new LoadCurrentUser());
    }
  }


  @Action(LoadCurrentUser)
  loadCurrentUser(ctx: StateContext<ProfileStateModel>): void {
    ctx.patchState({
      loadCurrentUserStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.service.loadCurrentUser().subscribe({
      next: currentUser => ctx.dispatch(new LoadCurrentUserSuccess(currentUser)),
      error: err => ctx.dispatch(new LoadCurrentUserFail(err))
    });
  }

  @Action(LoadCurrentUserSuccess)
  loadCurrentUserSuccess(ctx: StateContext<ProfileStateModel>, { currentUser }: LoadCurrentUserSuccess): void {
    ctx.patchState({
      loadCurrentUserStatus: PROGRESS_STATUSES.SUCCESS,
      currentUser
    });

    ctx.dispatch(new LoadUserRoles());
  }

  @Action(LoadCurrentUserFail)
  loadCurrentUserFail(ctx: StateContext<ProfileStateModel>, { error }: LoadCurrentUserFail): void {
    this.authService.logout();
    ctx.patchState({
      loadCurrentUserStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action([LoginSuccess])
  loginSuccess(ctx: StateContext<ProfileStateModel>): void {
    ctx.dispatch(new LoadCurrentUser());
  }

  @Action(LogoutSuccess)
  logoutSuccess(ctx: StateContext<ProfileStateModel>): void {
    ctx.setState(PROFILE_STATE_DEFAULT);
  }

  @Action([ResetAuthState])
  resetProfileState(ctx: StateContext<ProfileStateModel>): void {
    ctx.setState(PROFILE_STATE_DEFAULT);
  }

  @Action(UpdateProfile)
  updateProfile(ctx: StateContext<ProfileStateModel>, { user }: UpdateProfile): void {
    ctx.patchState({
      loadCurrentUserStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.service.updateUser(user).subscribe({
      next: currentUser => ctx.dispatch(new UpdateProfileSuccess(currentUser)),
      error: err => ctx.dispatch(new UpdateProfileFail(err))
    });
  }

  @Action(UpdateProfileSuccess)
  updateProfileSuccess(ctx: StateContext<ProfileStateModel>, { user }: UpdateProfileSuccess): void {
    ctx.patchState({
      loadCurrentUserStatus: PROGRESS_STATUSES.SUCCESS,
      currentUser: user
    });
  }

  @Action(UpdateProfileFail)
  updateProfileFail(ctx: StateContext<ProfileStateModel>, { error }: UpdateProfileFail): void {
    ctx.patchState({
      loadCurrentUserStatus: PROGRESS_STATUSES.FAIL
    });
  }
}


